function BarraDeProgresso({pontuacao, pontuacaoMax}) {
  return (
    <progress
      max={pontuacaoMax}
      value={pontuacao}
      style={{
        width: "27.188rem",
        height: "2.375rem",
        accentColor: "var(--cor-roxoEscuro)",
      }}
    ></progress>
  );
}

export default BarraDeProgresso
